import { render, staticRenderFns } from "./newVersion.vue?vue&type=template&id=a7cfdfa0&"
import script from "./newVersion.vue?vue&type=script&lang=js&"
export * from "./newVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports